var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortingDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125,2.661 L7.125,1.331 L16.459,1.331 L16.459,2.661 L7.125,2.661 ZM2.654,11.782 L0.459,9.591 L1.402,8.650 L2.459,9.705 L2.459,-0.000 L3.792,-0.000 L3.792,9.705 L4.849,8.649 L5.792,9.591 L3.597,11.782 C3.337,12.041 2.914,12.041 2.654,11.782 ZM14.459,5.323 L7.125,5.323 L7.125,3.992 L14.459,3.992 L14.459,5.323 ZM12.459,7.984 L7.125,7.984 L7.125,6.653 L12.459,6.653 L12.459,7.984 ZM10.459,10.645 L7.125,10.645 L7.125,9.315 L10.459,9.315 L10.459,10.645 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingDown);
export default __webpack_public_path__ + "static/media/sorting-down.05767fbc.svg";
export { ForwardRef as ReactComponent };